import * as React from 'react';
import {
  Droppable,
  DroppableDragEnterEvent,
  DroppableDragLeaveEvent,
  DroppableDropEvent
} from '@progress/kendo-react-common';
import { Component } from '../../../../dispatcher/modules';
import { 
  CONDITIONAL_FILTER_DROPPABLE_BOX_PROPS, 
  CONDITIONAL_FILTER_DROPPABLE_BOX_STATE 
} from './Types';

export class DroppableBox extends Component<CONDITIONAL_FILTER_DROPPABLE_BOX_PROPS, CONDITIONAL_FILTER_DROPPABLE_BOX_STATE> {
    private element: React.RefObject<HTMLElement | null> = React.createRef();

    constructor(props) {
      super(props);

      this.state = {
        isInside: false
      };
    }

    /**
     * Sets the drop target state to inside
     * @param {DroppableDragEnterEvent} e
     */
    handleDragEnter = (e: DroppableDragEnterEvent) => {
      this.setState({
        isInside: true
      });
    }

    /**
     * Sets the drop target state to leave
     * @param {DroppableDragLeaveEvent} e
     */
    handleDragLeave = (e: DroppableDragLeaveEvent) => {
      this.setState({
        isInside: false
      });
    }

    /**
     * Handles the drop event
     * Propagates the drop to a parent component via onDrop prop fn
     * @param {DroppableDragLeaveEvent} e
     */
    handleDrop = (e: DroppableDropEvent) => {
      this.setState({
        isInside: false
      });
      this.props.onDrop(this.props.index);
      this.props.handleDragging(false);
    }

    renderBody() {
      let { isInside } = this.state;

      return (
        <Droppable
          childRef={this.element}
          onDragEnter={this.handleDragEnter}
          onDragLeave={this.handleDragLeave}
          onDrop={this.handleDrop}
        >
          <div
            className={
              `tp-droppable-box ${isInside ? 'hover' : ''}`
            }
          >
            {this.props.children}
          </div>
        </Droppable>
      );
    }
}
